<template>
  <v-container>
    <v-progress-linear indeterminate :active="loading"></v-progress-linear>

    <v-row dense justify="center" align="center" v-if="error">
      <v-col cols="12" class="text-center">
        <v-icon size="82" color="red">mdi-close-circle-outline</v-icon>
      </v-col>
      <v-col cols="12" class="text-center">
        Não foi possível realizar o pré-agendamento!
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import bus from '@/plugins/eventBus';
import CalendarCard from '@/components/calendars/CalendarCard';
import ScheduleReminder from '@/components/calendars/ScheduleReminder';

export default {
  data: () => ({
    loading: true,
    preScheduleId: null,
    calendar: null,
    error: false
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  created() {
    this.preScheduleId = localStorage.getItem('mbpps');

    if(this.preScheduleId) {
      this.getCalendar();
    } else {
      this.error = true;
    }
  },
  methods: {
    preSchedule() {

      if(!this.calendar) {
        bus.$emit('message', {
          message: 'Erro ao tentar agendar.',
          type: 'error',
        });

        return;
      }

      const params = {
        schedule: {
          calendarId: this.calendar.calendarId,
          scheduleId: this.preScheduleId,
          date: this.calendar.schedule.date,
          time: this.calendar.schedule.time,
          speciality: null,
          calendarSpecialities: this.calendar.calendarSpecialities,
        },
        professional: {
          id: this.calendar.professionalId, // this.scheduleParams.professional.id ||
          name: this.calendar.professional,
          avatar: this.calendar.professionalAvatar,
        },
        patient: {
          id: this.user.id,
          name: this.user.name,
          avatar: this.user.avatar,
        },
        payment: {
          paymentAccountStatus: this.calendar.paymentAccountStatus,
          particular: false,
          price: this.calendar.price,
        },
        serviceChannel: {
          calendarServiceChannels: this.calendar.calendarServiceChannels,
          selected: { id: -1 },
        }
      };

      const queryBase64 = btoa(JSON.stringify(params));
      localStorage.removeItem('mbpps');

      this.$router.push({ name: 'schedule-confirmation', query: { q: queryBase64 } });
    },
    getCalendar() {
      this.$store
        .dispatch('calendars/getBySchedule', this.preScheduleId)
        .then((calendar) => {
          this.calendar = calendar;

          this.preSchedule();
        })
        .finally(() => {
          this.covenantsLoading = false;
        });
    },
  },
  components: {
    CalendarCard,
    ScheduleReminder,
  },
};
</script>
